import React from 'react';
import styled from 'styled-components';
import { Button } from '@tviklax/ui-components';
import { SchedulingStage, SCHEDULING_STAGE_ACTION_MAP } from './SchedulingContextTypes';

export interface SchedulingActionsProps {
  currentStage: SchedulingStage;
  onAction: (action: string) => void;
  isLoading?: boolean;
}

const ActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`;

const getActionLabel = (action: string): string => {
  const labels: Record<string, string> = {
    expedite: 'Expedite Order',
    'add-note': 'Add Note',
    approve: 'Approve',
    fail: 'Mark as Failed',
    'schedule-vessel': 'Schedule Vessel',
    'confirm-loaded': 'Confirm Loaded',
    reschedule: 'Reschedule',
  };
  return labels[action] || action;
};

const getActionVariant = (action: string): any => {
  if (action === 'fail') return 'error';
  if (action === 'approve') return 'primary';
  return 'default';
};

export const SchedulingActions: React.FC<SchedulingActionsProps> = ({
  currentStage,
  onAction,
  isLoading = false,
}) => {
  const allowedActions = SCHEDULING_STAGE_ACTION_MAP[currentStage] || [];

  if (allowedActions.length === 0) {
    return null;
  }

  return (
    <ActionsContainer>
      {allowedActions.map((action) => (
        <Button
          key={action}
          onClick={() => onAction(action)}
          disabled={isLoading}
          variant={getActionVariant(action)}
        >
          {getActionLabel(action)}
        </Button>
      ))}
    </ActionsContainer>
  );
};
